import type { ButtonConfig } from '../../declare'
import { useEffect, useMemo, useContext, useRef } from 'react'
import { toJS } from 'mobx'
import { EditOutlined, RollbackOutlined, CheckSquareOutlined, CopyOutlined } from '@ant-design/icons'
import { EasyModal, EasyIcon, EasyDrawer, EditPage, ListTableContext } from 'src/components'
import { $consts } from 'src/plugins'
import { set } from 'lodash'

type Props = {
  config: ButtonConfig
}

const EditRowBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  const initRecord = useRef<any>(null)
  useEffect(() => {
    if (props.config.__RECORD__ && !initRecord.current) {
      initRecord.current = toJS(props.config.__RECORD__)
    }
  }, [props.config.__RECORD__])

  const handleEdit = (edit: boolean, save?: boolean) => {
    const { __RECORD__: record } = props.config
    if (record.IS_DELETED) return

    const copyData = toJS(table.tableData.dataSource)
    const findIndex = copyData.findIndex((data: any) => data.ID === record.ID)
    if (edit) {
      set(copyData[findIndex], '__EDITABLE__', !save)
    } else {
      copyData.splice(findIndex, 1, initRecord.current)
    }
    table.setTableData({ dataSource: copyData })
  }

  const { __RECORD__: record, LABEL, ICON } = props.config
  if (record.__EDITABLE__) {
    return (
      <span>
        <RollbackOutlined
          title='还原'
          onClick={() => handleEdit(false)}
          className='fz-18 color-link mg-r12'
        />
        <CheckSquareOutlined
          title='确定'
          onClick={() => handleEdit(true, true)}
          className='fz-18 color-link'
        />
      </span>
    )
  }
  return (
    <span onClick={() => handleEdit(true)}>
      <EasyIcon type={ICON} defaultIcon='EditOutlined' className='fz-16' />
      <span title={LABEL} className='pd-l4'>{LABEL}</span>
    </span>
  )
}

const ListEditModalBtn = (props: Props) => {
  const formData = useMemo(() => {
    const { __RECORD__: record, BTN_TYPE } = props.config
    return {
      formId: record.ID,
      copyEdit: BTN_TYPE === $consts['TABLE/BTN_TYPE_COPY']
    }
  }, [props.config])

  const slot = useMemo(() => {
    const { __RENDER_SLOT__: renderSlot, LABEL } = props.config
    return renderSlot?.(props.config) ?? (
      <span>
        {formData.copyEdit ? <CopyOutlined className='fz-16' /> : <EditOutlined className='fz-16' />}
        <span title={LABEL} className='pd-l4'>{LABEL}</span>
      </span>
    )
  }, [props.config, formData.copyEdit])

  const { FORM_CODE, DRAWER_MODAL, WIDTH } = props.config
  if (DRAWER_MODAL) {
    return (
      <EasyDrawer drawer={{ title: FORM_CODE }} slot={slot}>
        <EditPage formCode={FORM_CODE} formData={formData} />
      </EasyDrawer>
    )
  }
  return (
    <EasyModal modal={{ title: FORM_CODE, width: WIDTH }} slot={slot}>
      <EditPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

const EditModalBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  // 动态列可编辑列表表单
  if (table.tableConfig?.Nav_Form?.FORM_TYPE === $consts['TABLE/FORM_TYPE_DYNAMIC_EDITLIST_PAGE']) {
    return <EditRowBtn config={props.config} />
  }
  // 列表表单
  return <ListEditModalBtn config={props.config} />
}

export default EditModalBtn